import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path, Rect } from '../IconBase/IconBase'

function PlusSecondary({
  color = 'icon.primary',
  fill = 'transparent',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 21 21' {...props}>
      <Rect
        x='5.14844'
        y='5.14648'
        width='14.5166'
        height='14.5166'
        rx='3'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M12.4091 10.334V14.4816'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M10.3359 12.411H14.4835'
        fill={fill}
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M5.14761 15.5166H4.11071C2.39271 15.5166 1 14.1239 1 12.4059V4.11071C1
        2.39271 2.39271 1 4.11071 1H12.4059C14.1239 1 15.5166 2.39271 15.5166
        4.11071V5.14761'
        fill={fill}
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

PlusSecondary.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default PlusSecondary
